import Box from "@mui/material/Box";
import Button, { ButtonProps } from "@mui/material/Button";

interface Props extends ButtonProps {
  title: string;
  link?: string;
  center?: boolean;
  onClick?: () => void;
}

const ButtonBlue = ({ title, center, onClick, ...props }: Props) => {
  return (
    <Box className="py-3">
      <Box className="py-3">
        {center ? (
          <Button
            style={{ padding: "10px 40px" }}
            onClick={onClick}
            sx={{
              backgroundColor: "#756DE9",
              borderRadius: "99px",
              fontSize: "16px",
              textTransform: "capitalize",
              width: "fit-content",
              "&:hover": {
                backgroundColor: "#756DE9",
              },
            }}
            variant="contained"
            className="w-100 next-btn mt-2 btn-pad"
            size="small"
            {...props}
          >
            {title}
          </Button>
        ) : (
          <Button
            style={{ padding: "15px 40px" }}
            onClick={onClick}
            sx={{
              backgroundColor: "#756DE9",
              borderRadius: "99px",
              fontSize: "16px",
              textTransform: "capitalize",
              width: "fit-content",
              "&:hover": {
                backgroundColor: "#756DE9",
              },
            }}
            variant="contained"
            className="w-100 mt-2 btn-pad"
            size="small"
            {...props}
          >
            {" "}
            {title}{" "}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ButtonBlue;
